import * as Effects from './effects'

export const SET_LOCATION = 'Comunidade.SET_LOCATION'
export const SET_ZIPCODE = 'Comunidade.SET_ZIPCODE'
export const SET_USE_LOCATION = 'Comunidade.SET_USE_LOCATION'
export const REQUEST_GET_SHOWCASE_STORES = 'Comunidade.REQUEST_GET_SHOWCASE_STORES'
export const REQUEST_GET_SHOWCASE_STORES_FINISHED = 'Comunidade.REQUEST_GET_SHOWCASE_STORES_FINISHED'
export const REQUEST_GET_SHOWCASE_OFFERS = 'Comunidade.REQUEST_GET_SHOWCASE_OFFERS'
export const REQUEST_GET_SHOWCASE_OFFERS_FINISHED = 'Comunidade.REQUEST_GET_SHOWCASE_OFFERS_FINISHED'
export const REQUEST_GET_LOCATION_FROM_ZIP_CODE = 'Comunidade.REQUEST_GET_LOCATION_FROM_ZIP_CODE'
export const REQUEST_GET_LOCATION_FROM_ZIP_CODE_FINISHED = 'Comunidade.REQUEST_GET_LOCATION_FROM_ZIP_CODE_FINISHED'

export function setLocation (location) {
  return createAction(SET_LOCATION, location)
}

export function setZipCode (zipCode) {
  return createAction(SET_ZIPCODE, zipCode)
}

export function setUseLocation (value) {
  return createAction(SET_USE_LOCATION, value)
}

export function getStoreShowcase () {
  return async (dispatch, getState) => {
    const { filters: { stores } } = getState().comunidade.showcase
    await createThunkEffect(dispatch, REQUEST_GET_SHOWCASE_STORES, Effects.getStores, stores)
  }
}

export function getOfferShowCase (type) {
  return async (dispatch, getState) => {
    const filter = getState().comunidade.showcase.filters[type]
    await createThunkEffectWitMeta(dispatch, REQUEST_GET_SHOWCASE_OFFERS, Effects.getOffers, type, filter)
  }
}

export function getLocationFromZipCode () {
  return async (dispatch, getState) => {
    const { zipCode } = getState().comunidade.showcase
    await createThunkEffect(dispatch, REQUEST_GET_LOCATION_FROM_ZIP_CODE, Effects.getLocationFromZipCode, zipCode)
  }
}

async function createThunkEffect (dispatch, actionType, effect, ...args) {
  dispatch(createAction(actionType))
  const model = await effect(...args)
  dispatch(createAction(`${actionType}_FINISHED`, model, false))

  return model
}

async function createThunkEffectWitMeta (dispatch, actionType, effect, meta, ...args) {
  dispatch(createAction(actionType))
  const model = await effect(...args)
  dispatch(createAction(`${actionType}_FINISHED`, model, false, meta))

  return model
}

function createAction (type, payload = undefined, error = false, meta = null) {
  return { type, payload, error, meta }
}



// WEBPACK FOOTER //
// ./src/features/MeuBairro/actions.js